import { render, staticRenderFns } from "./AddProspect.vue?vue&type=template&id=27e6e946&"
import script from "./AddProspect.vue?vue&type=script&lang=js&"
export * from "./AddProspect.vue?vue&type=script&lang=js&"
import style0 from "./AddProspect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports